

(function () {
  var query = window.location.search.substring(1);
  var parts = query.split('&');
  var motorId = '';
  var i;

  for (i = 0; i < parts.length; i++) {
    var pair = parts[i].split('=');

    if (decodeURIComponent(pair[0]) === 'motor') {
      motorId = decodeURIComponent(pair[1] || '');
      break;
    }
  }

  if (!motorId) {
    return;
  }

  var vehicleText = sessionStorage.getItem('racechip_vehicle');

  if (!vehicleText) {
    return;
  }

  var vehicle = JSON.parse(vehicleText);

  if (!vehicle || String(vehicle.vehicle_id) !== String(motorId)) {
    return;
  }

  function selectMotor() {
    var inputs = document.querySelectorAll(
      'input[type="radio"][name^="Motor"]'
    );


    var i;

    for (i = 0; i < inputs.length; i++) {
    if (
  inputs[i].value.replace(/\s+/g, ' ').replace(/\s*\/\s*/g, '/').trim() ===
  vehicle.engine.replace(/\s+/g, ' ').replace(/\s*\/\s*/g, '/').trim()
) {

        if (!inputs[i].checked) {
  inputs[i].click();
}

if (!inputs[i].checked) {
  inputs[i].click();
}

function hideMotorFieldset() {
  var currentInputs = document.querySelectorAll(
    'input[type="radio"][name^="Motor"]'
  );

  if (currentInputs.length > 0) {
    var fieldset = currentInputs[0].closest('fieldset');

    if (fieldset) {
      fieldset.style.display = 'none';
    }
  }
}

hideMotorFieldset();

var observer = new MutationObserver(function () {
  hideMotorFieldset();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

return true;
      }
    }

    return false;
  }

  var attempts = 0;

  var timer = setInterval(function () {
    attempts = attempts + 1;

    if (selectMotor() || attempts >= 20) {
      clearInterval(timer);
    }
  }, 250);
})();